import { Link } from "react-router-dom";
import { Nav } from "@/components/Nav";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Nav />
      <div className="max-w-3xl mx-auto px-4 py-32 text-center">
        <p className="font-mono text-xs text-[#FF3B30] mb-6">404 · OFF THE HIGH STREET</p>
        <h1 className="font-display text-6xl md:text-8xl tracking-tighter">Page not found.</h1>
        <Link to="/" className="inline-block mt-10 bg-[#FF3B30] text-white px-8 py-4 font-display font-bold">Back to work →</Link>
      </div>
    </div>
  );
}
